export default __webpack_public_path__ + "static/media/flipkart.45fa660a.png";